import { render, staticRenderFns } from "./QuizzMedia.vue?vue&type=template&id=5e22113e&"
import script from "./QuizzMedia.vue?vue&type=script&lang=ts&"
export * from "./QuizzMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports